import { CONFIDENCE_TokenOptions } from './auth0/auth';

export * from './auth0/auth.types';
export * from './auth0/useOrgId';

export * from './AuthFactoryContext';
export * from './testUtils';

export const TOKEN_OPTIONS = CONFIDENCE_TokenOptions;

export { store as authOverrideStore } from './override/store';

export {
  getCurrentLocationPath,
  hasOAuthCallbackParams,
  registerLogoutHandler,
} from './auth0/auth';
